import { render, staticRenderFns } from "./EditProductItemNew.vue?vue&type=template&id=392c5434&scoped=true"
import script from "./EditProductItemNew.vue?vue&type=script&lang=js"
export * from "./EditProductItemNew.vue?vue&type=script&lang=js"
import style0 from "./EditProductItemNew.vue?vue&type=style&index=0&id=392c5434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c5434",
  null
  
)

export default component.exports